// src/components/employee/MonthNavigator.jsx
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';


export default function MonthNavigator({ month, onChange, dark = false }) {
  const shift = (delta) => {
    const [y, m] = month.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    const next = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    onChange(next);
  };

  const label = (() => {
    const [y, m] = month.split('-').map(Number);
    if (!y || !m) return month;
    return new Date(y, m - 1, 1).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
  })();

  const base = dark
    ? 'bg-white/10 text-white border-white/20 hover:bg-white/20'
    : 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-white';

  return (
    <div className={`flex items-center gap-1 rounded-xl border ${base}`}>
      <button onClick={() => shift(-1)} className="p-1.5 rounded-l-xl hover:opacity-80 transition-opacity">
        <ChevronLeft size={14} />
      </button>
      <span className="text-xs font-semibold px-1.5 min-w-[80px] text-center">{label}</span>
      <button onClick={() => shift(1)} className="p-1.5 rounded-r-xl hover:opacity-80 transition-opacity">
        <ChevronRight size={14} />
      </button>
    </div>
  );
}
